import React from "react";

export const Spinner = () => (
  <div className="lds-ripple">
    <div></div>
    <div></div>
  </div>
);
